import * as React from "react";
import { SVGProps } from "react";

const Vesper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 1198 1198"
    {...props}
  >
    <style>{".st0{fill:#4138ac}"}</style>
    <path
      d="M599 0C268.2 0 0 268.2 0 599s268.2 599 599 599c330.7-.4 598.6-268.4 599-599C1198 268.2 929.8 0 599 0z"
      className="st0"
    />
    <circle id="Ellipse_16_22_" cx={599} cy={599} r={599} className="st0" />
    <path
      id="Path_12_27_"
      fill="#fff"
      d="M781.7 335.5 641 770.1 500.2 335.5H233.6l41.5 117.6h123.6l178.4 505.1h127.8l219.9-622.7H781.7z"
    />
  </svg>
);

export default Vesper;
